import React from 'react'
import { Box, Typography, styled } from '@mui/material'
import { Button, Modal } from '@/design-system'

const Footer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
  marginTop: 'var(--ds-space-4)',
})

export interface ConfirmModalProps {
  open: boolean
  onClose: () => void
  title: string
  description: string
  confirmLabel: string
  loading?: boolean
  onConfirm: () => void
}

export function ConfirmModal({ open, onClose, title, description, confirmLabel, loading, onConfirm }: ConfirmModalProps) {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      <Typography sx={{ fontSize: 13.5, color: 'var(--ds-ink-muted)', lineHeight: 1.6 }}>{description}</Typography>
      <Footer>
        <Button variant='ghost' onClick={onClose}>
          Cancel
        </Button>
        <Button variant='danger' loading={loading} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Footer>
    </Modal>
  )
}
